import * as React from 'react';
import greenMessage from '../../images/greenMessage.svg';
import greenClose from '../../images/greenClose.svg'
import { useState } from "react";
import { Container } from './BlueAlert';

type GreenAlertProps = {
    heading: string,
    message: string,
    open?: boolean,
    onClose?: () => void
}

export const GreenAlert: React.FC<GreenAlertProps> = ({heading, message, open = true, onClose}) => {
    const [isOpen, setIsOpen] = useState(open);

    const closeHandler = () => {
        setIsOpen(false);
        if (onClose) {
            onClose();
        }
    }

    return (
        isOpen ? <Container $color={'#EFFBF1'}>
            <img src={greenMessage} alt='' />
            <p><strong>{heading}</strong>{message}</p>
            <img src={greenClose} style={{marginLeft:'auto', marginRight: '0px', cursor: 'pointer'}} onClick={closeHandler} alt=''/>
        </Container> : null
    )
}